import React from 'react'
import PropTypes from 'prop-types'
import NewsItem from './components/NewsItem'
import styles from '../../styles.scss'

const Feed = (props) => {
    const newsItems = props.news.map(item => (
        <NewsItem key={item.published} {...item} onClick={props.onNewsClick} />
    ))
    return <div className={styles.feed}>{newsItems}</div>
}

Feed.propTypes = {
    // fetching: PropTypes.bool,
    // outdated: PropTypes.bool,
    news: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            link: PropTypes.string,
            published: PropTypes.string,
        }),
    ),
    onNewsClick: PropTypes.func,
}

export default Feed



// WEBPACK FOOTER //
// ./src/features/News/components/Feed/index.js